import React, { createContext, useEffect, useState } from 'react';
import { api as collectApi } from '@fiverr-private/collect';
import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_NAME } from '../../utils/constants';

const CollectionContext = createContext();

const CollectionProvider = ({ children }) => {
    const { userId }  = getContext();
    const [ collections, setCollections ] = useState([]);

    useEffect(
        () => {
            (async function fetchCollections() {
                if (userId) {
                    const { collections } = await collectApi.getCollections();
                    setCollections(collections);
                }
            })();
        },
        [userId]
    );

    const collectProps = {
        collections,
        onUpdateCollections: (collections = []) => {
            setCollections(collections);
        },
        isLoggedIn: !!userId,
        modalCustomName: PAGE_NAME
    };

    return (
        <CollectionContext.Provider value={{ collectProps }}>
            {children}
        </CollectionContext.Provider>
    );
};

export {
    CollectionProvider,
    CollectionContext
};
